
import studentData from '../data/students.json'
import teacherData from '../data/teachers.json'
import subjectData from '../data/subjects.json'
import marksData from '../data/marks.json'
import examsData from '../data/exams.json'
import attendanceData from '../data/attendance.json'
import noticeData from '../data/noticeData.json'
const initialState = {
    isAuthenticated: false,
    userType:"",
    studentData: studentData,
    subjectData: subjectData,
    teacherData: teacherData,
    marksData:marksData,
    examsData: examsData,
    attendanceData: attendanceData,
    noticeData: noticeData,

}
const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case "Login":
            console.log("logged in");
            return { ...state, isAuthenticated: true ,userType:"Admin" };
        case "Logout":
            console.log("logged out");
            return { ...state, isAuthenticated: false ,userType:"" };
        case "TeacherLogin":
            console.log("TEacher logged in");
            return { ...state, isAuthenticated: true ,userType:"Teacher" };
        case "StudentLogin":
            console.log("Student logged in");
            return { ...state, isAuthenticated: true ,userType:"Student" };
        case "ParentLogin":
            console.log("Parent logged in");
            return { ...state, isAuthenticated: true ,userType:"Parent" };

        case "AddStudent":
            console.log("Addedd");
            return { ...state, studentData: [...state.studentData, action.studentData] }

        case "DeleteStudent":
            console.log("Deleted ", state.studentData.filter(r => r.roll !== action.roll));
            return { ...state, studentData: state.studentData.filter(r => r.roll !== action.roll) }


        case "AddTeacher":
            return { ...state, teacherData: [...state.teacherData, action.teacherData] }

        default:
            return state;
    }
    return state;

}
export default rootReducer;